<template>
  <v-data-table
    :headers="headers"
    :loading="!!!documents"
    :items="documents"
    :sort-by="'id'"
    :sort-desc="true"
    :search="search"
    :items-per-page="10"
  >
    <template v-slot:top>
      <v-text-field
        v-model="search"
        :label="$t('DATA_TABLE.SEARCH')"
        outlined
        append-icon="mdi-magnify"
      ></v-text-field>
    </template>

    <template v-slot:item.title="{ item }">
      <a target="_blank" :href="item.url" style="cursor: pointer;">{{
        item.title
      }}</a>
    </template>

    <template v-slot:item.size="{ item }">
      {{ Math.round(item.size / 1000) }}
    </template>

    <template v-slot:item.action="{ item }">
      <div class="text-center">
        <v-menu transition="scale-transition" origin="center center">
          <template v-slot:activator="{ on }">
            <v-btn text icon x-small v-on="on">
              <v-icon>mdi-cog</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="$emit('edit', item)">
              <v-list-item-title>
                <v-icon class="mr-1" small>mdi-account-edit</v-icon>
                {{ $t('ITEM.EDIT') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="$emit('delete', item)">
              <v-list-item-title>
                <v-icon class="mr-1" small>mdi-delete</v-icon>
                {{ $t('ITEM.DELETE') }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'Documents',

  props: {
    documents: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    search: ''
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.TITLE'),
          value: 'title'
        },
        {
          text: this.$t('ITEM.TYPE'),
          value: 'type'
        },
        {
          text: `${this.$t('DOCUMENTS.SIZE')}, ${this.$t(
            'DOCUMENTS.KILOBYTES'
          )}`,
          value: 'size'
        },
        {
          text: this.$t('ITEM.DATE_ADDED'),
          value: 'created_at'
        },
        { text: '', value: 'action', align: 'center' }
      ];
    }
  }
};
</script>
